import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "v-visual-check" }
const _hoisted_2 = {
  key: 0,
  class: "yes"
}
const _hoisted_3 = {
  key: 1,
  class: "no"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'VCheck',
  props: {
    checked: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { checked: boolean }





return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.checked)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_v_icon, {
            icon: "mdi-check",
            size: "small"
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_v_icon, {
            icon: "mdi-close",
            size: "small"
          })
        ]))
  ]))
}
}

})